module.exports = __webpack_public_path__ + "img/ZainActive.a4a679fd.svg";